import React from "react";
import t from "utils/Lang";
import { Row, Col } from "reactstrap";
import CustomTextInput from "components/CustomTextInput";
import CustomQuestionInput from "components/CustomQuestionInput";

type QuestionProps = {
  updateAttr: (attribute: string, value: any) => void;
  data: any;
  errorData: any;
  isViewContract: boolean;
  fieldIsInvalid: (err: any) => boolean;
};

const Question = ({
  isViewContract,
  updateAttr,
  data,
  errorData,
  fieldIsInvalid,
}: QuestionProps) => {
  const uiConfigs = [
    {
      label:
        "Quyền sử dụng và kiểm soát tài sản thuê (Right-of-use and control of the lease asset)",
      items: [
        {
          attributeName: "right_of_use_and_control__alter_design_reallocate",
          type: "question",
          label:
            "Công ty có quyền sử dụng và kiểm soát tài sản thuê bao gồm việc thiết kế, thay đổi thiết kế, phân bổ lại tài sản không?",
          size: 12,
          options: [
            { label: "Có", value: true },
            { label: "Không", value: false },
          ],
        },
        {
          attributeName: "right_of_use_and_control__supervise_asset",
          type: "question",
          label:
            "Người thuê hay Người cho thuê có trách nhiệm giám sát tài sản thuê trong thời hạn thuê?",
          size: 12,
          options: [
            { label: "Người thuê", value: true },
            { label: "Người cho thuê", value: false },
          ],
        },
      ],
      id: 1,
    },
    {
      id: 2,
      label:
        "Quyền mua lại tài sản thuê khi hết hạn hợp đồng thuê (right to purchase the leased asset)",
      items: [
        {
          attributeName: "right_to_purchase_leased_asset",
          type: "question",
          label: "Công ty có quyền mua tài sản thuê khi hết hạn không?",
          size: 12,
          options: [
            { label: "Có", value: true },
            { label: "Không", value: false },
          ],
        },
        {
          attributeName: "right_to_purchase_leased_asset_value",
          type: "text",
          label: "Chi phí ước tính để mua tài sản thuê",
          size: 12,
          isNumeric: true,
        },
      ],
    },
    {
      id: 3,
      label: "Phí bảo trì (maintanance fee)",
      items: [
        {
          attributeName: "maintenance_fee_paid_by_leasee",
          type: "question",
          label:
            "Ai sẽ chịu trách nhiệm thanh toán phí bảo trì phát sinh trong thời hạn thuê?",
          size: 12,
          options: [
            { label: "Người thuê", value: true },
            { label: "Người cho thuê", value: false },
          ],
        },
        {
          attributeName: "maintenance_fee",
          type: "text",
          label: "Chi phí bảo trì (nếu có)",
          size: 12,
          isNumeric: true,
        },
      ],
    },
    {
      id: 4,
      label: "Điều khoản cho thuê lại (sublease the lease asset)",
      items: [
        {
          attributeName: "right_to_sublease",
          type: "question",
          label:
            "Công ty có cho đơn vị khác thuê lại tài sản thuê của mình không?",
          size: 12,
          options: [
            { label: "Có", value: true },
            { label: "Không", value: false },
          ],
        },
      ],
    },
    {
      id: 5,
      label: "Điều khoản chấm dứt hợp đồng (terminate term)",
      items: [
        {
          attributeName: "has_early_contract_termination_terms",
          type: "question",
          label:
            "Có điều khoản nào về việc chấm dứt hợp đồng sớm trước thời hạn không?",
          size: 12,
          options: [
            { label: "Có", value: true },
            { label: "Không", value: false },
          ],
        },
      ],
    },
    {
      id: 6,
      label: "Chi phí tháo dỡ (dismantling costs)",
      items: [
        {
          attributeName: "has_any_dismantling_cost",
          type: "question",
          label:
            "Có bất kỳ chi phí tháo dỡ nào được đề cập trong liên hệ không?",
          size: 12,
          options: [
            { label: "Có", value: true },
            { label: "Không", value: false },
          ],
        },
        {
          attributeName: "dismantling_cost_comment",
          type: "text",
          label:
            "Nếu có, nêu rõ đánh giá của ban quản lý về chi phí tháo dỡ đó",
          size: 12,
        },
        {
          attributeName: "estimated_dismantling_cost_value",
          type: "text",
          label: "Dự toán chi phí tháo dỡ nếu có?",
          size: 12,
          isNumeric: true,
        },
      ],
    },
  ];
  return (
    <>
      <h4 className="site-summary__label-title">{t().question}</h4>
      {uiConfigs.map((el) => (
        <div className="question-group" key={el.id}>
          <span className="question-label">{el.label}</span>
          <Row>
            {el.items.map((layoutItem, idx) => {
              if (layoutItem.type == "question") {
                return (
                  <Col
                    key={layoutItem.attributeName || `${idx}`}
                    sm={{ size: layoutItem.size, offset: 0 }}
                  >
                    <CustomQuestionInput
                      labelText={layoutItem.label}
                      attribute={layoutItem.attributeName}
                      callback={updateAttr}
                      data={data}
                      options={layoutItem.options || []}
                    />
                  </Col>
                );
              } else {
                return (
                  <Col
                    key={layoutItem.attributeName || `${idx}`}
                    sm={{ size: layoutItem.size, offset: 0 }}
                  >
                    <CustomTextInput
                      key={layoutItem.attributeName || `${idx}`}
                      disabled={isViewContract}
                      type={layoutItem.type}
                      isNumeric={layoutItem.isNumeric || false}
                      callback={updateAttr}
                      data={data}
                      labelText={layoutItem.label}
                      attributeName={layoutItem.attributeName}
                      invalid={fieldIsInvalid(
                        errorData?.[layoutItem.attributeName]
                      )}
                      formFeedbackText={errorData?.[layoutItem.attributeName]}
                    />
                  </Col>
                );
              }
            })}
          </Row>
        </div>
      ))}
    </>
  );
};

export default Question;
